<script>
  export default {
    props: ['servico', 'id'],
    data() {
      return {
        enviando: false
      }
    },
    methods: {
      enviar() {
        this.enviando = true;
        
        this.servico(this.id)
          .then(() => {
            this.enviando = false;

            this.$emit('enviado', this.id);
          })
          .catch(erro => {
            this.enviando = false;
            
            this.$emit('erro', erro, this.id);
          });
      }
    }
  }
</script>

<template>
  <button
    :disabled="enviando"
    class="btn btn-default btn-xs"
    v-tooltip="'Reenviar e-mail'"
    @click="enviar">
    <i v-show="!enviando" class="fa fa-envelope"></i>
    <i v-show="enviando" class="fa fa-refresh fa-spin fa-fw"></i>
  </button>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/BotaoReenviarEmail.vue